import React, { lazy } from "react";

import Form from "../components/Form";
import Header from "../components/Header";

const HassleFreeService = lazy(() => import("../components/HassleFreeService"));


const Benefits = lazy(() => import("../components/Benefits"));
const DocumentRequired = lazy(() => import("../components/DocumentRequired"));
const Calculator = lazy(() => import("../components/Calculator"));
const Faq = lazy(() => import("../components/Faq"));

function Home() {
  return (
    <>
 <Header />
      <Form />
      <HassleFreeService />
      <Benefits />
      <Calculator />
      
      <DocumentRequired />
     
      <Faq />
    </>
  );
}

export default Home;
